import { resetFileName } from '../utils/resetFileName';
import { toastMessage } from './toast';
import * as jobActions from '../Redux/Actions/jobs';

export const getDocumentId = async (files, userId, setButtonLoading, setAttachments) => {
    if(!files) {
        return;
    }

    setButtonLoading(true);
    let formData = new FormData();
    formData.append('userId', userId);
    formData.append('file', resetFileName(files));
    let woExtensionName = files?.name.toLowerCase().split('.');
    if(!(['jpeg', 'jpg', 'pdf', 'png']?.includes(woExtensionName.at(-1)))) {
        toastMessage('error', 'Un Supported Media type!');
        setButtonLoading(false);
        return;
    } 
    
    setAttachments(files);
    formData.append('extension', '.' + woExtensionName.at(-1));

    try {
        const res = await jobActions.uploadSingleDocument(formData);
        if(!(res?.status === 200)) {
            throw new Error(res);
        }
        setButtonLoading(false);
        return res.data;
    } catch(err) {
        toastMessage('error', 'Unable to upload Document!');
        setButtonLoading(false);
    }
};